import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
import { GeneralConstants } from '../../shared/general.constants';
import { ConfigService } from '../../shared/config.service';
import {DomSanitizer} from '@angular/platform-browser';
import {ApiConstants, CustomHttp} from '../../shared';



@Injectable()
export class TrailerService {

    private tarilerURL = '/trailers/v1/entity/';  // URL to web api


    constructor(private router: Router, private customHttp: CustomHttp,
        private http: Http, private generalConstants: GeneralConstants, private ApiConstants: ApiConstants, private configService: ConfigService, private sanitizer: DomSanitizer) {
    }

    getHelpdeskBaseUrl() {
        return this.ApiConstants.HELPDESK_API_URL;
    }

    createAuthorizationHeader(headers: Headers) {
        headers.append('x-auth-token', localStorage.getItem('id_token'));
        headers.append('Content-Type', 'application/json');
        return headers;
    }

    getTrailers(parrotId: any) {
        const url = this.getHelpdeskBaseUrl() + `${this.tarilerURL}${parrotId}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url, options)
            .map(res => res.json())
            .toPromise();
    }

    addTrailer(payload: string, parrotId) {
        const url = this.getHelpdeskBaseUrl() + `${this.tarilerURL}${parrotId}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.put(url, payload, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    deleteTrailer(parrotId: any, urlToBeDeleted) {
        const encodedUrlToBeDeleted = encodeURIComponent(urlToBeDeleted);
        const url = this.getHelpdeskBaseUrl() + `${this.tarilerURL}${parrotId}/trailer?trailer_url=` + encodedUrlToBeDeleted;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.delete(url, options)
            .map(res => res.json())
            .toPromise();
    }

    makePrimaryTrailer(payload: string, parrotId) {
        const url = this.getHelpdeskBaseUrl() + `${this.tarilerURL}${parrotId}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.patch(url, payload, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    mapIndividualTrailerItem(item) {
        // console.log(item);
        return {
            parrot_id: item.parrot_id,
            video_url : item.url,
            video_url_safe : this.parseVideoUrl(item.url),
            type: item.type.toLowerCase(),
            source: item.source,
            is_primary: item.is_primary,
            ordinal: item.ordinal,
        };
    }

    private parseVideoUrl(url) {
        let videoId = '';
        if (url.indexOf('youtube') !== -1) {
            url = url.substring(url.indexOf('=') + 1);
            videoId = 'https://www.youtube.com/embed/' + url;
        }else if (url.indexOf('vimeo') !== -1) {
            videoId = url.replaceAll('vimeo.com', 'player.vimeo.com/video');
        }else {
            videoId = url;
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(videoId);

    }

    deleteMapping(source: string, request: any, contentType) {
        const url = `${this.tarilerURL}/delete?source=` + source + `&content_type=` + contentType;
        return this.customHttp.put(url, JSON.stringify(request));
    }

    updateMapping(source: string, request: any, contentType) {
        const url = `${this.tarilerURL}?source=` + source + `&content_type=` + contentType;
        return this.customHttp.put(url, JSON.stringify(request));
    }

    handleMappingRequest(id: number, state: string, contentType) {
        let isAccept = false;
        if (state === 'approve') {
            isAccept = true;
        }
        const userName = localStorage.getItem('userName');

        const url = `${this.tarilerURL}/request?accept=${isAccept}&content_type=${contentType}&idMappingRequest=${id}&userName=${userName}`;
        return this.customHttp.get(url, { body: '' });
    }


    createMapping(source: string, request: any, contentType) {
        const url = `${this.tarilerURL}?source=` + source + `&content_type=` + contentType;
        return this.customHttp.post(url, JSON.stringify(request));
    }


    getMappingRequestTitleByState(state: string, contentType) {
        const url = `${this.tarilerURL}/request?state=` + state + `&content_type=` + contentType;
        return this.customHttp.get(url, { body: '' });
    }

    getMappingRequestTitleByStateNId(state: string, titleId: string, contentType) {
        const url = `${this.tarilerURL}/request?state=${state}&titleId=${titleId}&content_type=${contentType}`;
        return this.customHttp.get(url, { body: '' });
    }

    getLastCheckedDateForTitle(titleId: string, contentType) {
        const url = `${this.tarilerURL}/checkin?titleId=${titleId}&content_type=${contentType}`;
        return this.customHttp.get(url, { body: '' });
    }

    updateCheckedDateForTitle(titleId: string, requestUser: string, contentType) {
        const url = `${this.tarilerURL}/checkin?titleId=${titleId}&checkin=true&userName=${requestUser}&content_type=${contentType}`;
        return this.customHttp.get(url, { body: '' });
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/trailers/trailer.service.ts